export default __webpack_public_path__ + "static/media/svg-4.7bc67e7d.svg";